import { Space, Typography, Input, Checkbox } from 'antd'
import { useContext } from 'react'
import { useVisitQuery } from './apiQueries'
import EditVisitContext from './EditVisitContext'
const { Title } = Typography
const { TextArea } = Input

const NotesSection = () => {
  const { dispatch, visitId, internalNotes, clientNotes, sendNotification } = useContext(EditVisitContext)
  const visitQuery = useVisitQuery(visitId)

  const updateInternalNotes = (value?: string) => dispatch({ type: 'INTERNAL_NOTES_CHANGED', payload: value })
  const updateClientNotes = (value?: string) => dispatch({ type: 'CLIENT_NOTES_CHANGED', payload: value })

  const displayClientNotes = clientNotes ?? visitQuery.data?.clientNotes
  const displayInternalNotes = internalNotes ?? visitQuery.data?.internalNotes

  const clientNotesChanged = clientNotes !== undefined && clientNotes !== visitQuery.data?.clientNotes
  const internalNotesChanged = internalNotes !== undefined && internalNotes !== visitQuery.data?.internalNotes

  return <Space direction="vertical" style={{ width: '100%' }} size="small">
    <Title level={5}>Internal Notes</Title>
    <TextArea
      value={displayInternalNotes}
      status={internalNotesChanged ? 'warning' : undefined}
      onChange={(e) => updateInternalNotes(e.target.value)}
    />
    <Title level={5} style={{ marginTop: 0 }}>Client Notes</Title>
    <TextArea
      value={displayClientNotes}
      status={clientNotesChanged ? 'warning' : undefined}
      onChange={(e) => updateClientNotes(e.target.value)}
    />
    <Checkbox
      checked={sendNotification}
      onChange={x => dispatch({ type: 'SEND_NOTIFICATION_CHANGED', payload: x.target.checked })}
    >Send notification</Checkbox>
  </Space>
}
export default NotesSection
